export const environment = {
  production: false,
  ambiente: 'DEV',
  backendUrl: 'https://oauth-dev.useredecloud.com.br/api',
  recaptchaV3: {
    siteKey: '6LdydLskAAAAAGMOb77yOkzm8k9McU5M3T3SxQ-5'
  },
  appVersion: require('../../package.json').version
};
